export default "__VITE_ASSET__C7z7mhkq__"